var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgHt = function SvgHt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M0 0h640v240H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f1b517",
    stroke: "#000",
    strokeWidth: 0.183
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.286 179.654h151.428V300.2H244.286z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.475 266.826l-30.902.897-30.764.35s-15.806 5.845-22.266 7.157c-6.442 1.308-5.605 3.424-10.59 4.538-3.992.892-4.453 1.174-6.796 1.328-1.417.093-3.163 1.183-4.87 2.385v16.72h151.425v-15.902c-1.64-.895-3.205-1.51-4.806-2.054-2.224-.757-3.724-1.584-7.716-2.476-4.984-1.114-4.147-3.23-10.588-4.538-6.46-1.312-22.127-8.404-22.127-8.404z",
    fill: "#016a16",
    stroke: "#016a16",
    strokeWidth: 0.293
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.53 143.512l1.396-.033 2.555 10.748-.544 3.386-3.407-14.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.064 136.346l.954 8.284 1.022-.066-1.976-8.218z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.722 154.59l-4.293-11.54 1.6-.098 5.01 14.102-2.318-2.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42 136.477l1.77 8.02h1.432l-3.203-8.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.906 150.546l-2.52-5.424 1.09-.23 4.6 9.007-3.17-3.354z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.08 138.778l2.794 7.626h1.43l-4.224-7.626z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.25 151.364l-11.437-12.484c-3.57 2.828-2.908 8.02-2.908 8.02l12.957 10.167 1.387-5.703z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86 158.235l-8.482-8.594c-3.587.126-.74 5.48-.56 6.153l9.043 7.734v-5.292z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14 156.757l-17.54-18.78-.685.483 18.56 20.622-.336-2.325zm-18.554-19.985l-.385-.446.04-.89-3.62-2.304 1.617 3.64 1.232.223.384.446.732-.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.738 138.11c.616-.743 1.348-1.486 2.657-2.192l1 1.45-2.155 1.82-1.502-1.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81 141.278l.59 1.026c.363-.135 4.03-3.457 4.03-3.457l2.632-.08.756-.838c-1.932-2.08-3.752.296-3.752.296l-4.255 3.052z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.91 143.007c.14-.918 1.877-3.214 2.13-3.295 1.302.39 2.514 1.14 3.834-1.837-1.148 1.46-3.47-.027-3.47-.027l-1.01.838.03.405-3.053 2.837 1.54 1.08z",
    fill: "#d20014",
    stroke: "#d20014"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.252 154.672l-14.367-11.41c-2.46 2.502-.415 10.23-.415 10.23l14.043 7.608.74-6.428z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.166 163.917l-11.818-9.467c-4.036.566-.864 6.506-.623 7.16l12.48 6.77-.04-4.463z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.697 162.005l-25.554-19.182-.587.59 26.837 20.956-.696-2.365zm-26.769-20.198l-.46-.374-.122-.885-3.98-1.662 2.25 3.314 1.253.014.458.374.6-.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35 143.433c.472-.835 1.06-1.69 2.22-2.603l1.247 1.26-1.795 2.152-1.673-.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.925 146.64l.16 1.06c.337-.187 3.56-3.725 3.56-3.725l2.586-.477.528-.833c-1.797-2.114-3.713.698-3.713.698l-3.12 3.278z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.97 148.545c-.122-.982 1.22-3.863 1.456-3.98 1.547.46 2.894 1.152 3.462-2.07-.897 1.614-3.46.363-3.46.363l-.86.98.12.53-2.61 3.37 1.893.807z",
    fill: "#d20014",
    stroke: "#d20014"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.224 161.65c-.19-.045-18.517-10.44-18.517-10.44-1.334 2.25-.128 5.52.457 6.028.034 1.5-.602 2.306.707 5.44.387 2.035 1.33 3.912 2.7 5.026 1.672 6.417 8.223 6.848 10.747 1.624l3.907-7.677z",
    fill: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.352 168.512l-12.548-7.355c-4.036.567.085 8.056.326 8.71l12.116 4.304.106-5.658z",
    fill: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.243 165.846l-28.35-15.09-.484.673 29.904 16.646-1.07-2.23zm-29.715-15.909l-.514-.3-.265-.856-4.2-1.04 2.757 2.935 1.24-.177.515.3.466-.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.232 151.782c.332-.896.773-1.828 1.772-2.907l1.436 1.056-1.425 2.4-1.783-.548z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1 155.18l.593 1.168c.307-.232 3.004-4.578 3.004-4.578l2.492-.82.468-1.014c-2.002-1.85-3.498 1.342-3.498 1.342l-3.06 3.903z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.772 156.836c-.2-1 .484-4.197.7-4.345 1.56.466 2.863.598 3.223-2.62-.907 1.528-3.328.952-3.328.952l-.71 1.085.15.38-2.06 3.95 2.025.6z",
    fill: "#d20014",
    stroke: "#d20014"
  }))), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    transform: "matrix(-1 0 0 1 499.86 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.757 125.603l-.465 9.07h2.9l-.425-8.992 3.023-.423-.335-3.582-7.51.29.04 3.253 2.772.385z",
    fill: "#016a16",
    stroke: "#016a16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    fill: "#016a16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.817 121.898c-7.764-7.77-13.878-3.98-15.334-2.902.963.187 1.826-.412 2.273-.48-.28.353-.865 1.23-.865 1.23s2.4-1.135 2.67-1.03c-.347.275-.728.935-.728.935.178.07 1.528-1.056 1.795-1.076-.41.466-.54 1.528-.54 1.528l1.17-.545c.305.216-.084.63.18.61 1.945-.16 4.678 1.776 5.054 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.895 123.32c-.81-1.853-15.588-5.004-18.56.245 1.164.293 2.276-.976 2.276-.976l-.1 1.17 1.972-1.512-.708 1.56 1.568-1.268-.05 1.27 1.92-2.1-.252 1.22 1.72-.73-.203 1.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.238 123.614c-3.793-2.537-9.66-.83-9.66-.83-3.74 2.1-5.736 1.72-6.22 5.61.355-.145 1.366-1.365 1.366-1.365l.76 1.512.25-2.147.608 1.66.91-2.733.203 1.854 1.416-1.854.658.536.607-1.415.556.927s.962-.585 1.52-.244l1.06-1.22.253.88.91-1.074.355.78.91-.83-.05.586 3.135.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38 124.053c-2.643-.05-10.226 2.812-12.188 5.806a13.29 13.29 0 0 1 1.263-.636l.387 1.203.473-1.203.1.927c.29-.723.618-.805 1.164-.048l.2-1.122.305 1.073.505-1.17s.318 1.27.506 1.22c0 0 .838-2.195 1.214-2.294l.1 1.365.506-1.366.456 1.024.1-1.464.506 1.122s.266-1.103.658-1.317l.758.683 3.378-2.427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.888 124.678c-3.52 1.35-6.67 6.18-6.43 8.226 1.565-1.94 1.23-1.674 1.928.56 0 0 .264-1.955.53-2.187l.46 1.446.17-1.892.47.023-.12-1.187.698.535c-.163-.677-.338-.906.386-1.488 0 0-.917.117-.193-1.535l.675.65s-.12-.72.12-1l2.485-.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.23 125.04l-1.33 2.534.68.197-1.534 1.153 1.296-.132s-1.978.725-2.217 2.666l2.013-.888s-1.706 1.744-1.945 2.797l1.16-1.02s-1.125 1.217-.955 3.06l.853-.954c-.204 2.238-.136 2.436.888 4.147 0 0-.273-2.633.034-2.962l2.25 2.337-1.26-3.324s1.397 2.106 2.25 1.91l-1.774-2.7 1.74 1.415-1.978-2.96 1.84.558s-1.33-1.677-1.227-2.73l1.262 1.382s-.477-1.58-.34-2.04l.647.132-1.262-1.448.853-.165-.102-.953.615-.197-.034-1.053m-1.093-.005c-2.184 2.96-1.058 7.535-2.354 9.87"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 499.86 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.945 166.535s1.19-9.945 1.186-14.225c0-3.37-.813-10.835-.813-10.835H247.9s-.52 7.43-.442 10.79c.1 4.28 1.186 14.27 1.186 14.27h2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.674 141.953h3.96l-.465-2.666h-2.87l-.626 2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.927 139.816h3.54l-.668-2.666h-2.18l-.693 2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.155 137.655h2.95l-.5-2.666h-1.876l-.575 2.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71 134.673h-2.064l-.21.964h2.442l-.17-.964zm.422 29.694h-2.62m2.763-1.947h-2.94m3.329-1.976h-3.727m3.919-2.154h-3.9m3.927-2.15h-4.102m4.262-1.97h-4.45m4.46-1.79h-4.65m4.622-2.16h-4.65m4.495-2.136h-4.495m4.289-2.17H247.6m3.867-1.959h-3.672"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.91 119.044c-.69-.324-2.246-1.313-1.784-1.903l.713-1.213c1.01-2.277-.02-1.395-.127-2.106-.103-.68 3.865-.148 3.924 1.398.016.426-.295.176-.252 2.61l-.755 1.46c-.565.052-1.234-.015-1.72-.244z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.392 124.934l-.986-.83.273-7.105.964.282-.252 7.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.672 119.246c.62-.362 1.024-1.443.65-2.085-1.016-1.286-1.673-.755-3.378-1.335-.34.362-1.055 1.06-.902 1.58 2.242 1.055 1.372.155 2.114.287.4.07.658.545 1.516 1.554z",
    fill: "#d20014",
    stroke: "#d20014"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80) scale(1.6)"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#c",
    transform: "matrix(1 0 0 -1 -.002 320.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.358 161.75c0 1.3-.815 2.353-1.818 2.353-1.004 0-1.82-1.054-1.82-2.353v-1.276h3.638v1.276z",
    fill: "#016a16",
    stroke: "#fff",
    strokeWidth: 0.181,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.539,
    cy: 160.063,
    rx: 1.806,
    ry: 0.898,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.126 161.075l-.31-3.297h1.382l-.226 3.297h-.846z",
    fill: "#016a16",
    stroke: "#f1b517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M238.538 160.118c-.265.493-1.06.852-2 .852-.937 0-1.727-.36-1.992-.852a.756.756 0 0 0-.1.36c0 .668.938 1.21 2.093 1.21 1.154 0 2.09-.542 2.09-1.21a.748.748 0 0 0-.092-.36z",
    fill: "#016a16",
    stroke: "#fff",
    strokeWidth: 0.237,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.035 172.786l-7.06-2.19-3.076-5.254-10.894-.535.378 3.94 9.28 1.777.882 1.58 10.666 2.97-.177-2.288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.662 174.254l-11.149-16.398-.547.41 11.06 16.468.636-.48z",
    fill: "#503200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.55 158.5l-1.19-1.992c-.222-.368-.56-.49-1.058-.228-.484.255-.437.76-.24 1.123l1.1 1.852 1.39-.755z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.986 164.127l-22.496-2.286-.547 3.272 22.387 2.25.656-3.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09 160.997l-.584 4.538h.948l.656-4.15-1.02-.388zm3.754.738l-.255 4.08.582.07.474-3.622-.802-.528zm15.241 1.759l-.547 3.834 1.094-.035.437-3.8h-.985zm3.351.106l-.78 4.433 1.24.18.353-2.332c.1.47.53.825 1.045.825.59 0 1.07-.464 1.07-1.032 0-.568-.48-1.026-1.07-1.026-.41 0-.78.24-.94.687l.23-1.662-1.15-.073zm-8.119.72l-3.094 3.48.36.424 3.972-2.71-1.238-1.195zm-7.193 8.68l3.094-3.482-.36-.423-3.972 2.71 1.238 1.195zm8.096-.87l-3.764-2.91-.387.272 2.964 3.756 1.186-1.12zm-9.282-6.717l3.816 2.81.464-.348-2.99-3.755-1.29 1.293zm4.152-2.319l.365 4.573.513-.022 1.207-4.452-2.085-.1zm1.25 11.096l-.364-4.574-.565-.053-.69 4.626h1.62zm5.06-6.164l-4.794.51-.073.457 4.85.634.018-1.6zm-11.407 1.584l4.68-.74.1-.365-4.842-.54.063 1.644z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.693,
    cy: 168.548,
    rx: 1.27,
    ry: 1.225
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.438 168.548c0 3.592-3.022 6.507-6.745 6.507-3.723 0-6.745-2.915-6.745-6.507 0-3.592 3.022-6.507 6.745-6.507 3.723 0 6.745 2.916 6.745 6.508zm-1.347 0c0 2.874-2.418 5.207-5.397 5.207-2.98 0-5.398-2.333-5.398-5.207 0-2.874 2.42-5.207 5.398-5.207 2.98 0 5.398 2.334 5.398 5.208z",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48 165.264l-1.057-.796m8.611.025l.902-.92m1.031 9.127l-1.11-.87m-8.377 1.866l.954-1.02M246.196 162.122l1.155 5.886-.94.497-1.015-6.3.8-.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 161.364c-.535-.224-1.232.155-2.374-1.292-1.878 1.723-.107 1.98.18 3.686.53.218.857-1.323 2.3-1.48.18-.02 2.3-.204 2.3-.204l-.533-.726s-1.474.04-1.873.016z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36 162.518l-.215-1.756c-.232-.62-1-.087-1 .275l.197 1.62 1.017-.14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.765 167.372l.02 1.637c-.537.182-.455.584-.438 1.167l.02 4.772c-.19.315-.78.33-1.055.578-.277.248-.242.73 1.02 1.047l.975.035c1.486-.325 1.793-.818 1.048-1.095-.397-.148-.92-.324-1.117-.557l.033-1.137.965.036c.26 0 .753-.652.77-1.185l.005-2.47c-.035-1.4-1.085-1.558-1.38-1.54l.02-1.29-.885.002zm1.63 2.73c.018-.4-.555-.757-.786-.767-.23-.01-.735.467-.752.867v1c.034.367.327 1.61.915 1.7.28.044.64-.4.64-.766l-.017-2.034z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.275 172.328c-.636-.257-.63 1.172-.63 1.172l1.002.01c.44.2.792.843.512 1.16-.232.26-2.178-.442-2.31-.038.345 1.94 2.918 2.688 3.85 1.84.91-.832 1.14-3.05-1.818-3.63l-.607-.514zm.595.528l-.292.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.943 173.055l-.963-4.05m2.132 3.817l-1.48-3.153m4.026 2.324l-3.337-1.792m4.782 1.427l-6.192-2.688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.215 166.013s-2.254-.036-2.656.122c-.163.064.566.825.415 1.115-.563 1.083-4.394.934-4.697.698-.52-.405 3.568-.753 3.595-1.03.03-.315-.605-1.145-.506-1.654.128-.66 1.788-.907 1.788-.907l2.06 1.656z",
    fill: "#d20014",
    stroke: "#d20014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.233 168.05l-5.102-4.222s-.224-.238-.412-.033c-.184.2.07.43.07.43l5.262 4.35.183-.525z",
    fill: "#503200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.146 172.217c-.09-.087-4.155-3.608-4.155-3.608l-.27-1.03s-.628.426-.858.646c-.23.22-.587.82-.587.82l1.138.05 3.595 3.295 1.138-.173z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.534,
    cy: 177.056,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.641,
    cy: 175.716,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.091,
    cy: 176.593,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.153,
    cy: 177.445,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.487,
    cy: 177.64,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.846,
    cy: 177.64,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.18,
    cy: 177.591,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.988,
    cy: 176.325,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.604,
    cy: 176.398,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.144,
    cy: 176.203,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.361,
    cy: 174.961,
    rx: 0.74,
    ry: 0.715
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.846,
    cy: 174.937,
    rx: 0.74,
    ry: 0.715
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.47 177.99c0-.315-.77-.18-.77-.55 0-.41 1.174-.11 1.336.253.66-.596.944-.16 1.348.02.575-.855 1.287-.823 1.98-.197.402-.443 1.41-.297 1.758.197.664-.66 1.255-.497 1.715-.02.186-.346.458-.27.654-.02.355-.628 1.243-.44 1.617-.024.332-.367.673-.08 1.114.19.298-.28.78-.228.78.05 0 .288-.63.187-.63.473 0 .256.46.127.46.45 0 .255-.68.35-.786-.056-.23.44-1.062.27-1.144-.138-.276.334-.897.435-1.246-.06-.286.234-.63.267-.787.03-.517.557-1.388.443-1.688-.17l-.295.013c-.508.69-1.302.37-1.52-.01-.853.615-1.362.42-1.838.02-.548.666-1.38.62-1.573 0-.368.267-1.137.33-1.137.017 0-.3.653-.192.653-.47zm1.655.15c0 .144-.195.26-.436.26-.24 0-.436-.116-.436-.26 0-.142.195-.26.435-.26s.435.118.435.26zm1.82-.217c0 .172-.235.312-.524.312-.288 0-.523-.14-.523-.312 0-.173.235-.312.524-.312.29 0 .525.14.525.313zm3.575.197c0 .175-.212.316-.474.316s-.474-.14-.474-.316c0-.174.212-.316.474-.316s.474.142.474.316zm-1.904-.083c0 .22-.207.4-.463.4s-.464-.18-.464-.4c0-.22.207-.4.463-.4s.463.18.463.4zm4.06.01c0 .198-.186.358-.414.358-.23 0-.415-.16-.415-.358 0-.197.186-.357.415-.357.228 0 .414.16.414.357zm-1.244.083c0 .128-.12.23-.267.23-.148 0-.268-.102-.268-.23 0-.127.12-.23.268-.23.147 0 .267.103.267.23zm2.422.094c0 .183-.135.33-.302.33-.166 0-.3-.147-.3-.33 0-.183.134-.332.3-.332.167 0 .302.15.302.332z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "matrix(-1 0 0 1 499.86 0)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.231
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.837 165.718c-2.512 0-4.55.944-4.55 2.102 0 .2.057.39.17.572.542.63 2.306 1.087 4.397 1.087 1.957 0 3.625-.403 4.277-.97.165-.217.257-.447.257-.69 0-1.158-2.038-2.102-4.55-2.102z",
    fill: "#0a328c",
    stroke: "#0a328c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 167.98v7.06c0 .827-2.048 1.498-4.572 1.498s-4.573-.67-4.573-1.5v-7.057c0 .83 2.05 1.5 4.573 1.5 2.524 0 4.572-.67 4.572-1.5z",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.282 167.982v1.082l2.22 6.845 1.772-5.265 1.946 5.465 1.425-5.16 1.783 3.47v-1.92l-1.656-3.363a8.25 8.25 0 0 1-.593.134l-1.03 3.813-1.446-3.604a14.522 14.522 0 0 1-.715-.024l-1.454 3.627-1.66-4.367c-.377-.217-.594-.466-.594-.734z",
    fill: "#d20014",
    stroke: "#d20014",
    strokeWidth: 0.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 173.72v1.32c0 .826-2.048 1.498-4.572 1.498s-4.573-.672-4.573-1.5v-1.317c0 .83 2.05 1.5 4.573 1.5 2.524 0 4.572-.67 4.572-1.5z",
    fill: "#0a328c",
    stroke: "#0a328c",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.737 175.085c-.372.055-.77.097-1.185.118l.01 1.317c.418-.02.815-.062 1.187-.118l-.013-1.317zm-4.869-.23l-.012 1.312c.353.1.75.185 1.186.246v-1.317a8.907 8.907 0 0 1-1.174-.24zm-1.586-1.132v1.317c0 .246.185.474.506.68l.023-1.302c-.335-.21-.528-.443-.528-.695zm9.146.14l-.023.006c-.08.266-.38.515-.83.722l.005 1.312c.53-.245.848-.54.848-.863v-1.177z",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.427 168.027v7.012c0 .827-2.048 1.498-4.572 1.498s-4.573-.67-4.573-1.5v-7.01",
    fill: "none",
    strokeWidth: 0.187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.392 167.52c0 .5-1.584.907-3.537.907-1.954 0-3.538-.406-3.538-.907 0-.5 1.584-.907 3.538-.907 1.953 0 3.537.406 3.537.907z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.698 168.19l.157 1.25c.307.022.626.038.953.04l.232-1.29h-1.342zm4.102-.303l-.91.247.057 1.177c.31-.052.602-.116.866-.19l-.012-1.233zm-5.403-1.907c-.26.075-.5.164-.72.262l.127.945.58-.185.013-1.023zm2.44-.374c-.122 0-.24.007-.36.01l.197 1.184.605-.012.237-1.154a9.727 9.727 0 0 0-.68-.028zm2.673.418l-.122 1.034.69.244.077-1.015a5.26 5.26 0 0 0-.645-.263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.993 168.8l.184-1.288-.935-.506.028 1.465.723.33zm8.403-.278l.042-1.288-.876.262.834 1.026z",
    strokeWidth: 0.183
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.686 160.03c.83-.116 2.062 1.023 2.136 2.432.06 1.118-1.69 1.06-1.69 1.06-.09.458-1.055.88-1.84.916-.763.033.207-1.432.207-1.432-.476-1.26.147-2.748.147-2.748l1.04-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.5 162.948l.8-.03s.06.415.208.43c.157.018.326-.4.326-.4l1.217-.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.13 160.86c.68-.492.085-1.48-.385-1.49l-1.098.03c-.517.01-1.392.572-1.276 1.058.103.424.388.618.832.544.202-.033.626-.563.83-.572.276-.013.88.588 1.1.43z",
    fill: "#d20014",
    stroke: "#f1b517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.242 174.855c-.617.078-.73.788-.5 1.44-2.686.756-5.086 1.74-7.455 2.406-.095-.473 1.174-1.844 1.174-1.844.337.162.588.93.588.93.084-1.578 1.64-2.628 1.64-2.628-.925-.122-3.733.967-4.07 1.412 0 0 1.088-.12 1.256 0 0 0-2.14 2.312-2.237 3 .333.75 4.027 1.31 4.027 1.31-.058.196-1.087.932-1.087.932 1.47.322 3.685-.718 4.347-1.35 0 0-1.728-.144-3.074-1.235 0 0 .277.68.11 1.004 0 0-2.1-.604-2.318-.952.006-.03 4.966-1.315 7.368-2 .088.428.565 1.238 1.138 1.047.374-.125.256-.866.117-1.39a.77.77 0 0 0 .505.185c.422 0 .767-.327.767-.735 0-.407-.345-.74-.767-.74a.755.755 0 0 0-.72.505c-.096-.453-.345-1.354-.808-1.295zm1.89 1.528c0 .19-.162.345-.36.345a.352.352 0 0 1-.357-.345c0-.19.16-.345.358-.345.197 0 .358.154.358.345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M293.068 177.884c.183-.367-.162-2.212-.162-2.212-.373.042-.882.68-.882.68.48-1.51-.865-4.036-.865-4.036.91.19 3.944 3.128 4.102 3.657 0 0-1.33-.474-1.53-.415.217 1.506 1.258 2.205 1.65 2.988 0 0-1.726.38-1.553 1.822l-1.128.02c-.39-.48.152-1.275.152-1.275l-7.74-3.24c-.498-.21-1.62-.72-1.45-1.32.168-.603 2.015.252 2.47.4l6.934 2.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.635 176.54l.91-1.672c.326-.44-.346-.92-.823-.356l-1.02 1.527c-.454.836.5 1.066.933.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.293
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.187 288.586l-.1-2.92-3.532.195-.2 3.18 3.832-.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38 292.678l-4.722-2.648c19.47 1.784 23.446-5.006 28.15-5.37 2.893-.226 3.344 3.203-2.26 1.572l1.45 3.586s-13.822 7.776-27.407 4.564l4.79-1.704zm84.818-4.092l.1-2.92 4.32.1.202 3.18-4.622-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.902 291.963l4.443-2.424c-22.302.663-17.224-3.664-28.383-4.878-2.883-.313-5.05 3.393 2.26 1.572l-1.448 3.586 3.507.003c7.598 5.003 17.85 5.45 24.643 3.843l-5.02-1.703z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.47 286.253v5.047s12.364 4.587 34.43 4.587c22.16 0 34.43-4.587 34.43-4.587v-5.047s-9.36 4.312-34.43 4.312c-24.978 0-34.43-4.312-34.43-4.312z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.317 291.328l1.09-3.695.508.14-.963 3.258 1.887.52-.13.436-2.393-.658zm3.578-1.625l.06-.726.164-.622.54.13-.164.624-.31.664-.29-.07zm5.32-.25l.517.102-.46 2.175c-.08.38-.187.67-.322.876a1.158 1.158 0 0 1-.596.448c-.26.094-.58.104-.955.03-.367-.07-.653-.19-.86-.358a1.056 1.056 0 0 1-.386-.625c-.05-.25-.034-.574.05-.972l.46-2.176.515.102-.46 2.172c-.068.327-.088.575-.057.742a.7.7 0 0 0 .25.422c.135.114.313.193.535.236.38.075.668.045.865-.09.196-.134.344-.437.444-.91l.458-2.172zm.582 4.017l.642-3.792.533.085 1.56 3.302.504-2.977.5.08-.644 3.79-.534-.084-1.56-3.305-.505 2.98-.498-.08zm4.065.614l.547-3.806.52.07-.546 3.806-.522-.07zm1.5-1.68c.075-.632.31-1.11.706-1.428.395-.32.87-.45 1.43-.388.364.04.683.16.957.362.273.2.47.46.587.778.118.318.155.668.11 1.05a2.212 2.212 0 0 1-.367 1.012 1.657 1.657 0 0 1-.77.618 2.046 2.046 0 0 1-.99.13 1.923 1.923 0 0 1-.966-.37 1.69 1.69 0 0 1-.584-.785 2.097 2.097 0 0 1-.114-.978zm.54.07c-.055.46.03.835.255 1.128.225.293.53.46.918.504.394.043.734-.055 1.02-.294.286-.24.46-.605.517-1.096.037-.31.014-.588-.067-.832-.08-.243-.22-.44-.414-.59a1.33 1.33 0 0 0-.682-.27c-.37-.04-.704.047-1 .263-.297.216-.48.61-.547 1.186zm3.693 2.265l.324-3.83.538.042 1.83 3.17.255-3.006.503.04-.324 3.83-.54-.043-1.83-3.174-.254 3.008-.503-.04zm5.582.387l.174-3.838 2.685.112-.02.453-2.158-.09-.053 1.187 1.867.08-.02.452-1.867-.08-.08 1.745-.525-.023zm2.934.125l1.607-3.813.568.01 1.552 3.872-.6-.01-.44-1.173-1.666-.032-.46 1.155-.56-.01zm1.182-1.556l1.35.025-.395-1.07a9.822 9.822 0 0 1-.266-.802c-.055.245-.13.488-.23.73l-.458 1.118zm3.06 1.617l.01-3.842.526.002-.008 3.842h-.527zm2.47-.01l-.05-3.39-1.313.02-.008-.454 3.156-.045.007.454-1.317.017.05 3.388-.527.008zm3.906-.093l-.186-3.838.526-.024.165 3.385 1.96-.088.02.453-2.485.112zm2.68-.117l1.242-3.937.567-.04 1.908 3.72-.598.043-.55-1.13-1.66.114-.35 1.19-.56.04zm1.03-1.652l1.346-.092-.493-1.033c-.15-.314-.262-.572-.34-.775a4.75 4.75 0 0 1-.16.746l-.352 1.154zm4.675 1.213l-.437-3.818 2.67-.285.052.45-2.147.23.136 1.182 1.858-.198.052.45-1.858.2.198 1.734-.524.056zm2.92-2.192c-.094-.63.01-1.15.307-1.554.3-.406.726-.647 1.282-.723.364-.05.704-.01 1.02.116.318.126.576.33.773.61.198.278.325.607.38.988.06.386.03.742-.088 1.068-.116.327-.31.59-.583.786a2.02 2.02 0 0 1-.923.367c-.37.05-.714.008-1.032-.124a1.736 1.736 0 0 1-.77-.616 2.124 2.124 0 0 1-.365-.92zm.54-.065c.067.458.248.802.542 1.03.295.23.635.317 1.02.264.393-.056.696-.233.91-.534.215-.302.286-.697.213-1.187a1.922 1.922 0 0 0-.282-.79 1.25 1.25 0 0 0-.556-.47 1.348 1.348 0 0 0-.73-.094c-.37.05-.67.217-.9.498-.23.28-.303.708-.218 1.28zm4.18 1.29l-.71-3.78 1.737-.305c.35-.06.62-.074.815-.038.195.036.363.13.504.284.14.153.23.333.27.54.05.27.002.51-.143.727-.146.215-.402.38-.768.496a1.4 1.4 0 0 1 .347.133c.177.107.35.25.525.427l.875.91-.652.114-.667-.696a7.436 7.436 0 0 0-.472-.455 1.198 1.198 0 0 0-.31-.207.818.818 0 0 0-.256-.06c-.06 0-.16.01-.292.034l-.602.105.316 1.68-.518.09zm.122-2.203l1.114-.195a1.74 1.74 0 0 0 .542-.17.588.588 0 0 0 .302-.636.573.573 0 0 0-.284-.405c-.156-.09-.38-.112-.67-.06l-1.24.216.235 1.252zm6.29-.42l.543.016c-.013.43-.134.783-.364 1.058-.23.275-.548.456-.952.544-.42.09-.78.082-1.08-.025a1.63 1.63 0 0 1-.765-.585 2.57 2.57 0 0 1-.44-.96c-.09-.39-.093-.747-.006-1.072.087-.324.256-.592.506-.805.25-.213.547-.357.89-.43.388-.085.737-.06 1.047.073.31.133.557.36.74.685l-.478.226c-.154-.254-.33-.424-.53-.51a1.098 1.098 0 0 0-.69-.047c-.3.064-.533.187-.702.368a1.102 1.102 0 0 0-.292.648c-.027.25-.01.5.047.747a2.3 2.3 0 0 0 .34.803c.15.217.342.362.572.435.23.075.464.086.7.035a1.14 1.14 0 0 0 .676-.4c.162-.203.242-.47.24-.8zm1.463 1.046l-1.07-3.7 2.773-.748.127.437-2.265.61.328 1.134 2.12-.57.127.433-2.122.572.365 1.26 2.354-.635.127.437-2.86.77z",
    fill: "#000",
    stroke: "none"
  }))));
};
export default __webpack_public_path__ + "assets/c0cb323cb8dd92f165aa1894e1839f30.svg";
export { SvgHt as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ht.svg